import { Controller } from "stimulus"
import savingEmittingSave from "./save_emitting_rails_ajax"

export default class extends Controller
  @values =
    updateUrl: String
    attribute: String
  
  # Saves the content in the editor. This will get be called any time the enabled
  # editor inside this controller loses focus (blurs).
  save: (event) ->
    content = event.target.value

    data = new FormData()
    data.append @attributeValue, content

    savingEmittingSave @element, 'PATCH', @updateUrlValue, data, 'json'